import * as ajax from "../../../actions/ajaxCounterActions";
import * as exception from "../../../actions/exceptionActions";
import * as domainConstants from "../../../constants/DomainConstants";

import financieelApi from "../../../api/financieelApi";
import documentApi from "../../../api/documentApi";
import { getFilesForDossierComponent } from "../../common/DownloadUploadFilesHelper";

import { getStore } from "../../../store/configureStore";

import showToastr from "../../../util/toastr.js";

export default class OverzichtPageHelper {
	constructor(context, redirector) {
		this.dispatch = getStore().dispatch;
		this.context = context;
		this.redirector = redirector;
		this.timer = null;
	}

	init() {
		this.context.setState({
			financieelOverzicht: null
		});

		const dossierId = this.context.props.dossierId;
		this.getTotalenByDossierId(dossierId);
		this.getDocumentenByDossierId(dossierId);
	}

	loadLayout(financieel) {
		const dossierId = this.context.props.dossierId;

		this.context.props.loadLayout(financieel.naam, financieel.tabTitel, dossierId, financieel.typeDossier);
	}

	loadBeads(beadModels) {
		this.context.props.beadsLoaded(beadModels);
	}

	getTotalenByDossierId(dossierId) {
		this.dispatch(ajax.started());
		financieelApi.getTotalenByDossierId(dossierId)
			.then(response => {
				this.dispatch(ajax.ended());
				this.setStateAfterUpdate(response.data);
				this.loadBeads(response.data.beadModels);
				this.loadLayout(response.data);
			})
			.catch(error => {
				this.dispatch(ajax.failed(error));
				this.dispatch(exception.throwException(error));
			});
	}

	getDocumentenByDossierId(dossierId) {
		this.dispatch(ajax.started());
		documentApi.getContent(dossierId, domainConstants.DocumentTab.MinimaleEisen)
			.then(response => {
				this.dispatch(ajax.ended());

				this.context.setState({
					documenten: response.data
				});
			})
			.catch(error => {
				this.dispatch(ajax.failed(error));
				return {
					success: false,
					data: error
				};
			});
	}

	generateRapport() {
		const dossierId = this.context.props.dossierId;
		this.dispatch(ajax.started());
		this.context.setState({
			documenten: []
		});

		financieelApi.generateRapportDuurzaamheid(dossierId)
			.then(response => {
				this.dispatch(ajax.ended());
				this.setStateAfterUpdate(response.data);
				showToastr(domainConstants.PDF_GENEREREN);
				this.handleOnStartInterval();
			})
			.catch(error => {
				this.dispatch(ajax.failed(error));
				this.dispatch(exception.throwException(error));
			});
	}

	handleOnStartInterval() {
		const dossierId = this.context.props.dossierId;
		this.context.setState({ pollCount: 0 });
		this.timer = setInterval(() => {
			if (this.context.state.pollCount > 19)
				this.handleOnStopInterval();

			documentApi.getContent(dossierId, domainConstants.DocumentTab.MinimaleEisen)
				.then(response => {
					if (response.status == 200) {
						if (getFilesForDossierComponent(domainConstants.ComponentName.DuurzaamheidsRapport, response.data).length > 0) {
							this.context.setState({
								documenten: response.data
							});
							this.handleOnStopInterval();
						}
					}
					this.context.setState({ pollCount: this.context.state.pollCount + 1 });
				})
				.catch(error => {
					this.context.setState({ pollCount: this.context.state.pollCount + 1 });
					this.dispatch(ajax.failed(error));
					return {
						success: false,
						data: error
					};
				});
		}, 20000);

		this.context.setState({ timer: this.timer });
	}

	handleOnStopInterval() {
		clearInterval(this.timer);
		this.context.setState({ timer: null });
	}

	isReadyToRender() {
		if (!this.context.state.financieelOverzicht) {
			return false;
		}

		if (this.context.props.okiTypes.length < 1) {
			return false;
		}

		return true;
	}

	setStateAfterUpdate(item) {
		this.context.setState({
			financieelOverzicht: item
		});
	}

}